import React from 'react'
import { css } from 'styled-components'
import CheckboxSelected from '../../../icons/CheckboxSelected'
import CheckboxUnselected from '../../../icons/CheckboxUnselected'

const CheckboxWrapper = ({ checked, label, onClick, ...props }) => (
  <div
    onClick={onClick}
    css={css`
      display: flex;
    `}
  >
    <div
      css={`
        margin: 0.125rem 0.6225rem 0 0.0625rem;
      `}
    >
      {checked ? <CheckboxSelected /> : <CheckboxUnselected />}
    </div>
    <label {...props}>{label}</label>
  </div>
)

export default CheckboxWrapper
